import {
  Col,
  Form,
  Row
} from "react-bootstrap";
import {
  useState
} from "react";
import { useTranslation } from 'react-i18next';
import { Button, Modal } from "react-bootstrap";

export const ModalNewModel = (props: any) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal as={Modal.Dialog}         
        centered show={props.show} 
        onHide={props.close} >
        <Modal.Header>
          <Button variant='close' aria-label='Close' onClick={props.close} />
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="align-items-center">
              <Col xs="7">
                <Form.Group>
                  <Form.Control style={{ display: 'none' }} ></Form.Control>
                  <Form.Label>{t('MODEL_MODAL.ENTER_NEW_MODEL_NAME')}</Form.Label>
                  <Form.Floating>
                    <Form.Control
                      name='code_equipment'
                      id='code_equipment'
                      type='text'
                      className='form-control'
                      onChange={props.changeValue}
                      maxLength={20}
                      />
                  </Form.Floating>
                </Form.Group>
              </Col>
              <Col xs="5">
                <Button
                    variant='primary'
                    style={{ marginLeft: "auto" }}
                    className='text-gray ms-auto me-2 mt-4'
                    onClick={props.save}>
                    {t('BUTTON_SAVE')}
                </Button>
                <Button
                    variant='primary'
                    style={{ marginLeft: "auto" }}
                    className='text-gray ms-auto mt-4'
                    onClick={props.close}>
                    {t('CANCEL')}
                </Button>
              </Col>
            </Row>            
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalNewModel;
